import { render } from "./OfflineScreen.vue?vue&type=template&id=586d5e2f&scoped=true"
import script from "./OfflineScreen.vue?vue&type=script&lang=ts"
export * from "./OfflineScreen.vue?vue&type=script&lang=ts"

import "./OfflineScreen.vue?vue&type=style&index=0&id=586d5e2f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-586d5e2f"

export default script